module.exports = __webpack_public_path__ + "static/media/service_system_12.c0ad4482.png";